<template>
  <div class="sky-page-software-view" ref="SkyDeployCollectSoftwareTable">
    <div class="page-from-item wsp-display-flex wsp-padding-tb-12">
      <div class="page-from-value from-value">
        <el-button type="primary" @click="onSubmit" v-if="reportId">确定</el-button>
        <el-button @click="cancel">取消</el-button>
        <el-button @click="ReportCreate" type="success" v-if="!reportId">手工添加客户环境信息</el-button>
      </div>
    </div>
    <div
      v-if="!reportId"
      class="wsp-display-flex-center font-size-16  color-E69D01 bg-3bb113 backgroud-color-rgb0004"
      style="height: 200px; width: 100%;"
    >
      当前桌面未绑定采集报告，请先上传或绑定之后进行选择软件
    </div>
    <div v-if="reportId">
      <div class="wsp-display-flex wsp-line-height-36">
        <div class="wsp-text-align-right"><strong>已绑定报告：</strong></div>
        <div>{{ reportDetail.customer }}</div>
        <div>
          <i class="el-icon-error color-ec2805 wsp-padding-left-3" @click="removeBindReport(reportDetail)"></i>
        </div>
      </div>
    </div>
    <div class="page-from-item" v-if="reportId">
      <div class="page-from-value">
        <div class="page-function-toolbar">
          <el-button icon="el-icon-refresh" class="toolbar-left" @click="refushTable"></el-button>
          <el-input
            placeholder="请输入软件名称查询"
            class="toolbar-input"
            size="medium"
            v-model="searchKeyword"
            @blur="searchReq"
            @change="searchReq"
          >
            <span slot="suffix" class="el-input__suffix"
              ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
            </span>
          </el-input>
          <div class="el-icon-warning wsp-padding-lr-6 wsp-line-height-24 bg-red">
            当前筛选对大小写敏感
          </div>
          <el-pagination
            class="toolbar-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handelPrev"
            @next-click="handelNext"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="total,sizes,prev,sp,next"
            :current-page="page"
            :page-size="pageSize"
            :total="pageTotal"
          >
          </el-pagination>
        </div>
        <el-table
          ref="table"
          height="600"
          :border="true"
          :data="listData"
          :show-header="true"
          :column-drag-sortable="false"
          class="sky-host-dist"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" :selectable="enableSelect"> </el-table-column>
          <el-table-column
            :label="$t('pocMng.soft.softwareName')"
            prop="softwareName"
            show-overflow-tooltip
            width="275"
          />
          <el-table-column
            :label="$t('pocMng.soft.softwareVersion')"
            prop="softwareVersion"
            width="125"
            show-overflow-tooltip
          />
          <el-table-column label="兼容情况" prop="hasCompatible" show-overflow-tooltip
            ><template slot-scope="scope">
              <div v-if="scope.row.compat.length > 0">
                <span>
                  <el-tag :type="`${dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['type']}`">
                    {{ dictionary['compatibleStatus'][scope.row.compat[0].compatibleStatus]['label'] }}
                  </el-tag>
                  <span>【{{ scope.row.compat[0].productVersion }}】及以上</span>
                </span>
              </div>
              <div v-else>
                <el-tag type="warning">未知</el-tag>
              </div>
            </template></el-table-column
          >
        </el-table>
      </div>
    </div>

    <el-drawer
      ref="drawer"
      :key="drawerKey"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="40%"
      :before-close="handleCloseDrawer"
      direction="rtl"
    >
      <div class="relation-page-group">
        <div class="wsp-group-title">
          <div class="wsp-group-title-icon"></div>
          <div class="wsp-group-title-value">客户环境采集报告选择</div>
        </div>
      </div>
      <report-table @chagneSceneRelation="bindDesktopReport"></report-table>
    </el-drawer>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination, RadioGroup, RadioButton, Input, Tag, Drawer } from 'element-ui'

import reportTable from './reportTable'

import dictionary from '../../../../../utils/dictionary'

import { getSoftwareList } from '@/api/collect'
import reportCreateForm from '@/store/modules/pocMng/metaData/reportCreateForm'

// import lang from '@/lang'
export default {
  name: 'SkyDeployCollectSoftwareTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Drawer.name]: Drawer,
    reportTable
  },
  props: {
    customer: {
      type: String,
      default: function() {
        return null
      }
    },
    reportId: {
      type: String,
      default: function() {
        return null
      }
    },
    reportDetail: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data: function() {
    return {
      selectItem: null,
      drawerKey: 0,
      dialogVisible: false,
      dictionary: dictionary,
      listData: [],
      searchKeyword: '',
      pageTotal: 0,
      pageSize: 20,
      reqParmas: {
        exactMatchArr: [],
        matchArr: [],
        page: this.page - 1,
        limit: 20
      },
      page: 1
    }
  },
  created() {},
  mounted() {
    if (this.reportId) {
      this.getData()
    }
  },
  methods: {
    getData() {
      this.reqParmas.page = this.page - 1
      this.reqParmas.limit = this.pageSize

      var req = JSON.parse(JSON.stringify(this.reqParmas))
      if (this.reportId) {
        req.matchArr.push({
          type: 'EXACT',
          fieldName: 'reportId',
          valueArr: [this.reportId],
          matchRule: 'EQ'
        })
      }

      getSoftwareList(req).then(res => {
        this.listData = res.data.content.itemArr
        this.pageTotal = res.data.content.total
      })
    },
    cbAction(reportInfo) {
      this.reportId = reportInfo.id
      this.reportDetail = reportInfo
      this.$emit('bindDesktopReport', { select: reportInfo })
      this.getData()
    },
    ReportCreate({ commit }, params) {
      this.$store.SkyDeployCollectSoftwareTableBindSuccessCallback = this.cbAction
      const props = {
        'view.content[$id=customer].$el': { disabled: true },
        'view.content[$id=customer].$default': this.customer,
        'view.showOkBtn': false,
        'view.showCancelBtn': false,
        'view.callBackAction': 'EnvCollectReportSuccess',
        toolbar: {
          items: [
            {
              slot: 'refresh-rigtht',
              label: 'confirm',
              props: {
                type: 'primary',
                disabled: false
              },
              action: 'AfterReportCreate'
            },
            {
              slot: 'refresh-rigtht',
              label: 'cancel',
              action: 'ReturnPage'
            }
          ]
        },
        extraParams: {
          collectView: this
        }
      }
      this.$store.dispatch('OpenFullDialog', {
        metaData: reportCreateForm,
        props
      })
    },
    handleCloseDrawer() {
      this.dialogVisible = false
    },
    bindReport() {
      this.dialogVisible = true
    },
    refushTable() {
      this.getData()
    },
    enableSelect(row, index) {
      if (row.compat.length > 0) {
        if (row.compat[0].compatibleStatus === 'NOT_SUPPORTED') {
          return false
        }
        return true
      }
      return true
    },
    searchReq() {
      if (this.searchKeyword !== '') {
        //
        const exists = this.reqParmas.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParmas.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParmas.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['softwareName'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParmas.matchArr.length; index++) {
          const element = this.reqParmas.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParmas.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    onSubmit() {
      this.$emit('addSelect', { select: this.selectItem, type: 'SpecPositionSoftware' })
    },
    handleSelectionChange(val) {
      this.selectItem = val
    },
    cancel() {
      this.$parent.$parent.$parent.closeDrawer()
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    removeBindReport() {
      this.reportId = null
      this.reportDetail = {}
      this.$emit('removeBindReport', { report: this.reportDetail })
    },
    bindDesktopReport(params) {
      this.reportId = params.select.id
      this.$emit('bindDesktopReport', params)
      this.handleCloseDrawer()
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-software-view) {
  height: 100%;
  .page-from-item {
    padding: 0 6px;
    line-height: 28px;
    .page-from-item-label {
      font-size: 14px;
      font-weight: 600;
    }
    .page-from-label {
      width: 8%;
    }
    .from-value {
      padding-left: 12px;
    }
    .page-from-item-value {
    }
  }
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
